import { Trans } from 'react-i18next';
import { ColumnsType } from 'common/components/antd/Table/Table';
import { alphabeticSortFn } from 'common/utils/sort.utils';
import { EBranchesColumnKeys } from './enums/branches.enum';
import { TBranchesTableRecord } from './types/branches.types';

export const getColumns = (): ColumnsType<TBranchesTableRecord> => [
  {
    title: <Trans i18nKey="usrRoleMng.branches.table.column.name" />,
    width: 238,
    key: EBranchesColumnKeys.Name,
    dataIndex: EBranchesColumnKeys.Name,
    searchable: true,
    sorter: alphabeticSortFn(EBranchesColumnKeys.Name),
  },
];
